<script lang="ts">
	import { t } from 'svelte-i18n';
	import ProjectsGallery from '@app/components/projects/ProjectsGallery.svelte';
	import AlertInfo from '@app/components/alerts/AlertInfo.svelte';
	import { goto } from '$app/navigation';
	import { urls } from '@app/urls';
	import ButtonBoxTextColor from '$lib/elements/buttons/variants/ButtonBoxTextColor.svelte';
	import { signInUpModalStore } from '@app/stores/signInUpModal';

	export let data;
	$: ({ operations, regulation, user } = data);
	let title = $t('projectsPage.titlePrivateAccess');
</script>

{#if user}
	{#if operations}
		<ProjectsGallery {data} {title} {regulation} isPrivateOperations={true} />
	{/if}
{:else}
	<div class="container py-5">
		<h1 class="text-center">{title}</h1>
		<div class="pt-5">
			<AlertInfo label={$t('privateOperationAlertTitle')}>
				<div slot="body">
					<div class="flex flex-col gap-5 lg:flex-row xl:gap-8">
						<div class="basis-1/2">
							<p>
								{@html $t('privateOperationCTAHelp')}
							</p>
							<ButtonBoxTextColor
								props={{ label: $t('projectsPage.privateAccessCTALabel') }}
								on:click={async () => {
									await goto(urls.PROJECT.PRIVATE_ACCESS);
								}}
							/>
						</div>
						<div class="basis-1/2">
							<p>
								{@html $t('privateOperationLoginHelp')}
							</p>
							<ButtonBoxTextColor
								props={{ label: $t('nav.header.login') }}
								on:click={async () => {
									signInUpModalStore.open();
								}}
							/>
						</div>
					</div>
				</div>
			</AlertInfo>
		</div>
	</div>
{/if}
